export const isSelectionEnabled = (params: {
	isIntegrationValid: boolean;
	noDefaultRepository: boolean;
}) => {
	const { isIntegrationValid, noDefaultRepository } = params;
	return isIntegrationValid || noDefaultRepository;
};
